import {
    IProps,
} from './types';

import React, {
    FC,
} from 'react';

import {
    Modal,
} from 'components/other';

import styles from './MediaViewerModal.module.scss';

const MediaViewerModal: FC<IProps> = (props) => {
    return (
        <Modal
            className={styles.mediaViewerModal}
            isOpen={props.isOpen}
            onClose={props.onClose}
        >
            <img
                className={styles.media}
                src={props.mediaUrl ?? ''}
                alt={''}
            />
        </Modal>
    );
};

export default MediaViewerModal;
